import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { MenuItem, Select } from "@material-ui/core";

import { putNomencladorBandeja } from "../../../../actions/autorizaciones/Autorizaciones";

const AbmBandejaItem = (props) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState('');
  // const [value, setValue] = useState(props.item.idBandejaAutorizacion || "");

  const onChangeHandler = (e) => {
    setValue(e.target.value);

    const data = {
      idCodNom: props.item?.idCodNom,
      idBandejaAutorizacion: e.target.value,
    };

    dispatch(putNomencladorBandeja(data));
  };
  
  useEffect(() => {
    setValue(props.item.idBandejaAutorizacion);
  }, [props.item.idBandejaAutorizacion]);

  return (
    <Select fullWidth value={value} onChange={onChangeHandler}>
      {props.bandejas.map((bandeja) => (
        <MenuItem key={bandeja?.idBandeja} value={bandeja?.idBandeja}>
          {bandeja?.descripcion}
        </MenuItem>
      ))}
    </Select>
  );
};

export default AbmBandejaItem;
